var _excluded = ["children", "className", "style", "headerChildren"],
    _excluded2 = ["children", "className", "style", "minimal", "headerChildren"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { hyperStyled } from "@macrostrat/hyper";
import { Button } from "@blueprintjs/core";
import * as styles from "./main.module.sass";
var h = hyperStyled(styles);

var PanelHeader = function PanelHeader(props) {
  var title = props.title,
      onClose = props.onClose,
      children = props.children;
  return h("div.panel-header", [h["if"](title != null)("h1.title", null, title), h["if"](children != null)([h("div.expander"), children, h("div.extra-space")]), h(Button, {
    minimal: true,
    icon: "cross",
    onClick: onClose
  })]);
};

function MinimalModalPanel(props) {
  var children = props.children,
      className = props.className,
      style = props.style,
      headerChildren = props.headerChildren,
      rest = _objectWithoutProperties(props, _excluded);

  return h("div.panel-column", [h("div.panel.minimal", {
    className: className,
    style: style
  }, [h(PanelHeader, rest, headerChildren), h("div.panel-content", null, children)]), h("div.expander")]);
}

function ModalPanel(props) {
  var children = props.children,
      className = props.className,
      style = props.style,
      _props$minimal = props.minimal,
      minimal = _props$minimal === void 0 ? false : _props$minimal,
      _props$headerChildren = props.headerChildren,
      headerChildren = _props$headerChildren === void 0 ? null : _props$headerChildren,
      rest = _objectWithoutProperties(props, _excluded2);

  if (minimal) {
    return h(MinimalModalPanel, _objectSpread(_objectSpread({}, rest), {}, {
      children: children,
      headerChildren: headerChildren,
      className: className,
      style: style
    }));
  }

  return h("div.panel-column", [h("div.panel-container", [h("div.panel-container-inner", [h("div.panel-outer", [h("div.panel", {
    className: className,
    style: style
  }, [h(PanelHeader, rest, headerChildren), h("div.panel-content", null, children)]), h("div.expander")])])])]);
}

var ContentPanel = function ContentPanel(props) {
  return h("div.content-panel", props);
};

export * from "./draggable-overlay";
export { ModalPanel, PanelHeader, ContentPanel };